import '@biopeak/ui/global.css';

import { cssVariables } from '@biopeak/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { SessionProvider } from './lib/session.tsx';

// ÚNICO app do produto que liga a paleta semântica do semáforo — o painel do
// médico é ferramenta de trabalho (build-prompt §8.3/§8.4); o app do paciente
// nunca recebe essas cores, nem embarcadas no bundle.
const tokenStyle = document.createElement('style');
tokenStyle.textContent = `:root { ${cssVariables({ includeStatusPalette: true })} }`;
document.head.appendChild(tokenStyle);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root nao encontrado');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <App />
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
